<template lang="pug">
  v-img(
    contain
    max-height="100%"
    :src="src")
</template>

<script>
import src from './yako.png'

export default {
  setup () {
    return {
      src
    }
  }
}
</script>
